export const useBookingCreation = () => {
  const getMaxSegmentDuration = (hold_segments = []) => {
    const segmentDurations = hold_segments.map((ts) => Number(ts.duration))
    return Math.max(...segmentDurations)
  }

  const getMeetTypes = (hold_segments = [], types = []) => {
    const maxSegmentDuration = getMaxSegmentDuration(hold_segments)
    return types.filter((mt) => mt <= maxSegmentDuration)
  }

  return { getMeetTypes, getMaxSegmentDuration }
}
